<template>
  <v-dialog v-model="dialog" max-width="600">
    <ValidationObserver ref="addCommentForm" v-slot="{ invalid, passes }">
      <form
        rel="addCommentForm"
        class="flex flex-wrap justify-between sm:justify-center"
        @submit.prevent="passes(submit)"
      >
        <v-card>
          <v-card-title class="pa-7">Nový komentář</v-card-title>
          <v-card-text class="pa-7">
            <v-row>
              <v-col cols="12" class="py-0 px-5">
                <VTextAreaWithValidation
                  v-model="content"
                  rules="required"
                  mode="lazy"
                  outlined
                  dense
                  label="Komentář"
                  data-cy="comment"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pl-7 pr-7 pb-7">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :loading="saving"
            >
              Uložit
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import VTextAreaWithValidation from '@/components/validators/VTextAreaWithValidation'
import { mapActions } from 'vuex'
export default {
  name: 'OrderCommentAddDialog',
  components: { VTextAreaWithValidation },
  data() {
    return {
      content: null,
      saving: false,
      dialog: false,
    }
  },
  created() {
    const model = this
    this.$eventBus.$on('addCommentDialog', function (dialog) {
      model.content = null
      model.dialog = dialog
    })
  },
  methods: {
    ...mapActions({
      createOrderComment: 'order/createOrderComment',
    }),
    submit() {
      this.saving = true
      this.createOrderComment({ id: this.$route.params.orderId, content: this.content }).finally(
        () => {
          this.saving = false
          this.$refs.addCommentForm.reset()
          this.$emit('commentAdded')
          this.close()
        }
      )
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
